import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
const propTypes = {
  width: PropTypes.oneOf(['standard', 'narrow'])
};
const SkeletonTextLine = createComponent({
  displayName: 'SkeletonTextLine',
  root: 'div',
  propTypes,
  propConfig: {
    classNames(props) {
      const {
        width
      } = props;
      const classNameSet = new Set(['swan-skeleton-text-line swan-bgc-loading-shimmer']);
      if (width === 'narrow') classNameSet.add("swan-skeleton-text-line-narrow");
      return classNameSet;
    }
  }
});
SkeletonTextLine.defaultProps = {
  width: 'standard'
};
export { SkeletonTextLine };